<template>
  <v-stepper-header>
    <template v-for="(item, index) in steps">
      <v-stepper-step
        :key="item.name"
        :complete="maxStep > index + 1"
        :step="index + 1"
        :class="{ movableStep: isMovable(index) }"
        @click="onClickStep(item, index)"
      >
        {{ stepText(item, index) }}
      </v-stepper-step>
      <v-divider v-if="steps.length > index + 1" :key="`${item.name}Divider`" />
    </template>
  </v-stepper-header>
</template>

<script>
export default {
  name: 'CampaignModalNav',
  props: {
    step: {
      type: Number,
      default: 1,
    },
    steps: {
      type: Array,
      required: true,
    },
    maxStep: {
      type: Number,
      required: true,
    },
    editable: {
      type: Boolean,
      default: true,
    },
    isNarrow: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClickStep(item, index) {
      if (this.isMovable(index)) {
        this.$emit('change', index + 1)
      }
    },
    isMovable(index) {
      if (!this.editable) return false
      const stepNum = index + 1
      return this.step > stepNum || this.maxStep >= stepNum
    },
    stepText(item, index) {
      return this.isNarrow && this.step - 1 !== index ? '' : item.title
    },
  },
}
</script>

<style lang="scss" scoped>
.movableStep {
  cursor: pointer;

  &:hover {
    background-color: #f5f5f5;
  }

  &.v-stepper__step--inactive {
    ::v-deep .v-stepper__step__step {
      background-color: rgba(#1976d2, 0.6) !important;
    }
  }
}
</style>
